import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const carsManagementReducer = foxGridReducer(gridNames.carsManagement);

export default carsManagementReducer;
